module.exports = require('./class')();



//////////////////
// WEBPACK FOOTER
// ./~/jpex/src/index.js
// module id = 568
// module chunks = 40